import { Locale } from '@ps-smart-cp/ppfw-client';

const fixedAssetIncreDecreTotalTableReportTypeClassConfig = {
  fixedAssetIncreDecreTotalTable: new Map([[Locale.ja, '固定資産増減合計表']]),
  fixedAssetIncreDecreTotalTableDetails: new Map([[Locale.ja, '固定資産増減合計表(詳細)']]),
};

export { fixedAssetIncreDecreTotalTableReportTypeClassConfig };
